import '../styles/Dash.scss'

import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
// import { getAvailableRanges, getData } from '../api/data'
import DateSlider from './DateSlider'
// import Loading from './Loading'
import MultiSelector from '../shared/MultiSelector'
import LoadingOverlay from 'react-loading-overlay'
// import Charts from './Charts'
import moment, { max, min } from 'moment'
// import { DASH_MODE } from './App'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Map from './Map'
import Loading from '../Loading'
import { getAvailableRanges, getData, getOwnReport, getOwnReports, saveOwnReport } from '../../dummy-data/DUMMYDATA'
import { getAuthentication, isReportIssuer } from '../../api/auth'
import qs from 'qs'
// import { ReadingsTable } from './ReadingsTable'
import { ReadingsTable } from '../shared/ReadingsTable'
import Modal from 'react-modal'

import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
// import 'react-date-range/dist/styles.css'; // main css file
// import 'react-date-range/dist/theme/default.css'; // theme css file
// import { DateRangePicker } from 'react-date-range';

// import { DateRangePicker } from 'rsuite'

// const {
//   allowedRange,
//   combine
// } = DateRangePicker

import { RangePicker } from 'react-minimal-datetime-range'
import 'react-minimal-datetime-range/lib/react-minimal-datetime-range.min.css'
// import BigNumbers from './BigNumbers'
import BigNumbers from '../shared/BigNumbers'
import ReportCharts from './ReportCharts'
import { downloadTextFile, readingsToCsv } from '../../utils/utils'
import Logo from '../Logo'

// import Datetime from 'react-datetime'
// import 'react-datetime/css/react-datetime.css'

class ReadingsExplorer extends Component {
  constructor(props) {
    super(props)

    // console.log(this.props.location.query)
    // console.log(this.props)

    const query = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })

    this.state = {
      query: query,
      reportId: undefined,
      isSaved: false,
      filters: undefined,
      aggregatedValues: undefined,
      readings: undefined,
      downloading: false,
      showFilters: true,
      minDt: undefined,
      maxDt: undefined,
      saveFormOpen: false,
      reportName: undefined,
      _reportNameInput: undefined,
    }
  }

  componentDidMount() {
    this.fetchOptions()
  }

  componentDidUpdate(_prevProps, prevState) {
    // If the filters changed, fetch new data
    if (this.state.filters && JSON.stringify(prevState.filters) !== JSON.stringify(this.state.filters)) {
      this.fetchData()

      this.setState({
        isSaved: false,
      })
    }
  }

  fetchOptions() {
    getAvailableRanges().then((res) => {
      // Set available options
      console.log(res)
      this.setState({
        options: {
          ...res,
          minDt: moment(res.fromDt),
          maxDt: moment(res.toDt),
        },
      })

      // Set default filters if not passed in path
      // if (!this.state.query || Object.keys(this.state.query).length === 0) {

      // const maxDt = moment(res.toDt)
      // const minDt = moment.max(moment(res.fromDt), maxDt.clone().subtract(15, 'days'))
      const maxDt = moment().year(2019).month(7).date(31).hour(23).minute(59).second(59)
      const minDt = moment().year(2019).month(7).date(0).hour(0).minute(0).second(0)

      this.setState({
        reportName: `${minDt.format('YYYY-MM-DD')} a ${maxDt.format('YYYY-MM-DD')}`,
        filters: {
          fromDt: minDt,
          toDt: maxDt,
          granularity: 'month',
          dataFilters: res.dataFilters,
        },
      })

      // }
      // else {

      //   if (this.state.query.ownReportId) {
      //     // Fecth report filters
      //     getOwnReport(this.state.query.ownReportId).then(res => {
      //       console.log(res)
      //       const inFilters = res.filters
      //       this.setState({
      //         reportId: this.state.query.ownReportId,
      //         isSaved: true,
      //         filters: {
      //           fromDt: moment(inFilters.fromDt),
      //           toDt: moment(inFilters.toDt),
      //           dataFilters: inFilters.dataFilters
      //         }
      //       })

      //     })

      //   }

      // }
    })
  }

  fetchData() {
    this.setState({ downloading: true })
    getData(this.state.filters, isReportIssuer() ? undefined : getAuthentication().entity)
      .then((res) => {

        // Parse dates
        res.filters.fromDt = moment(res.filters.fromDt)
        res.filters.toDt = moment(res.filters.toDt)
        for (let index = 0; index < res.readings.length; index++) {
          res.readings[index].opDt =moment(res.readings[index].opDt)
        }

        this.setState({
          reportName: '', //`${res.filters.fromDt.format('YYYY-MM-DD')} a ${res.filters.toDt.format('YYYY-MM-DD')}`,
          aggregatedValues: res.aggregatedValues,
          filters: res.filters,
          readings: res.readings,
          // rawReadings: res.rawReadings,
          residual: res.residual,
          downloading: false,
        })
      })
      .catch((err) => {
        console.log(err)
        this.setState({ downloading: false })
      })
  }

  setDataFilter(name, values) {
    this.setState((prevState) => ({
      filters: {
        ...prevState.filters,
        dataFilters: {
          ...prevState.filters.dataFilters,
          [name]: values,
        },
      },
    }))
  }

  isDateInAvailableRange = (dt) => {
    return dt.isBetween(this.state.options.minDt, this.state.options.maxDt, null, '[]')
  }

  saveReport = () => {
    saveOwnReport(this.state._reportNameInput, this.state.filters).then((res) => {
      this.setState({
        saveFormOpen: false,
        reportName: this.state._reportNameInput,
      })
      toast.success(res)
    })
  }

  exportCsv = () => {
    if (this.state.readings && this.state.readings.length > 0 && this.state.reportName) {
      let csv = readingsToCsv(this.state.readings)
      const fileName = `${this.state.reportName}.csv`
      downloadTextFile(fileName, csv)
    }
  }

  render() {
    if (!this.state.options || !this.state.filters) {
      return <Loading />
    }

    const dateSlider = () => {
      return (
        <div>
          <DateSlider
            minDt={moment(this.state.options.fromDt)}
            maxDt={moment(this.state.options.toDt)}
            onChange={(dates, granularity) => {
              // console.log(dates, granularity)
            }}
          />
        </div>
      )
    }

    const selectors = () => {
      const _options = this.state.options.dataFilters
      const _filters = this.state.filters ? this.state.filters.dataFilters : undefined

      let _selectors = [
        {
          name: 'SST',
          options: _options.sst,
          selectedValues: _filters ? _filters.sst : [],
          onChange: (values) => this.setDataFilter('sst', values),
        },
        {
          name: 'Serviço',
          options: _options.service,
          selectedValues: _filters ? _filters.service : [],
          onChange: (values) => this.setDataFilter('service', values),
        },
        {
          name: 'Frota',
          options: _options.fleet,
          selectedValues: _filters ? _filters.fleet : [],
          onChange: (values) => this.setDataFilter('fleet', values),
        },
      ]

      if (isReportIssuer()) {
        _selectors = [
          {
            name: 'Operador',
            options: _options.operatorName,
            selectedValues: _filters ? _filters.operatorName : [],
            onChange: (values) => this.setDataFilter('operatorName', values),
          },
        ].concat(_selectors)
      }

      return _selectors
    }

    const renderData = () => {
      if (this.state.downloading) {
        return <Loading />
      }

      if (!this.state.readings || this.state.readings.length === 0) {
        return (
          <div className="container has-text-centered mt-6">
            <h1 className="title has-text-dark">Não existem registos que cumpram os filtros definidos.</h1>

            <p className="title has-text-dark mt-6" style={{ fontSize: '10rem' }}>
              <FontAwesomeIcon icon="exclamation-triangle" />
            </p>
          </div>
        )
      }

      return (
        <div className="">
          <ToastContainer />

          <nav className="level ml-6 mr-6">
            <div className="level-left">
              <div className="sie-title-container py-1 mt-6 ">
                <h4 className="title">Relatório de Dados</h4>
                <h5 className="subtitle" style={{ fontWeight: 'bold' }}>
                  {this.state.reportName} {this.state.reportId && <FontAwesomeIcon icon="save" />}
                </h5>
              </div>
            </div>

            <div className="level-right">
              {/* 
              <div className="field is-grouped has-addons">

                <p className="control">
                  <button className="button is-primary" onClick={this.exportCsv}>
                    <span className="icon is-small">
                      <FontAwesomeIcon icon='file-csv'/>
                    </span>
                    <span>Exportar para CSV</span>
                  </button>
                </p>
              </div>
                 */}
            </div>
          </nav>

          <div className="mx-5 mt-6">
            <BigNumbers records={this.state.readings} isPrint={false} operatorName={getAuthentication().entity} isExplorer/>
          </div>

          <div className="mx-5 mt-6">
            <ReportCharts data={this.state.readings} isReportIssuer={isReportIssuer()} />
          </div>

          <div className="mx-5 mt-6">
            <div className="subtitle sie-title-container mt-5 ml-5">
              <h1 className="subtitle ">Mapa de Consumo por SST</h1>
            </div>
            <Map data={this.state.readings} />
          </div>

          <div className="mx-5 mt-6">
            <ReadingsTable readings={this.state.readings} isPrint={false} exportCsv={this.exportCsv} />
          </div>
        </div>
      )
    }

    const renderSideBar = () => {
      return (
        <>
          <div>
            <div
              className="sidebar"
              style={{
                width: this.state.showFilters ? '20vw' : '4vw',
                paddingLeft: this.state.showFilters ? '20px' : '5px',
                paddingRight: this.state.showFilters ? '20px' : '5px',
                // paddingTop: '1vh'
              }}
            >
              <div style={{ display: this.state.showFilters ? 'none' : 'block' }}>
                <button
                  className="button"
                  onClick={() => this.setState({ showFilters: true })}
                  style={{ width: '3vw' }}
                >
                  <FontAwesomeIcon className="" icon="sliders-h" />
                </button>
              </div>

              <div style={{ display: this.state.showFilters ? 'block' : 'none' }}>
                <div>
                  <a className="closebtn" onClick={() => this.setState({ showFilters: false })}>
                    &times;
                  </a>
                </div>

                {/* {dateSlider()} */}

                <Logo small />

                <div className="has-text-centered mt-3 mb-6">
                  <button className="button is-primary" onClick={() => this.setState({ saveFormOpen: true })}>
                    Guardar Relatório
                  </button>
                </div>


                <h3 className="mt-3 mb-1">Datas</h3>

                <RangePicker
                  locale="en-us" // default is en-us
                  show={false} // default is false
                  disabled={false} // default is false
                  allowPageClickToClose={true} // default is true
                  onConfirm={(res) => {
                    this.setState({
                      filters: {
                        ...this.state.filters,
                        fromDt: moment(res[0]),
                        toDt: moment(res[1]),
                      },
                    })
                  }}
                  style={{ width: '100%', margin: '0 auto', height: '46px' }}
                  placeholder={['Data Início', 'Data Fim']}
                  defaultDates={[
                    this.state.filters.fromDt.format('YYYY-MM-DD'),
                    this.state.filters.toDt.format('YYYY-MM-DD'),
                  ]}
                  defaultTimes={[
                    this.state.filters.fromDt.format('HH:mm:ss'),
                    this.state.filters.toDt.format('HH:mm:ss'),
                  ]}
                  initialDates={[
                    this.state.options.minDt.format('YYYY-MM-DD'),
                    this.state.options.maxDt.format('YYYY-MM-DD'),
                  ]}
                  initialTimes={['00:00', '23:59']}
                />
                {/* <Datetime
                  inputProps={{
                    style: { textAlign: 'center' ,
                      width: '100%',
                      boxSizing: 'border-box',
                      transition: 'all .2s ease',
                      height: '38px',
                      fontSize: '1em',
                      border: '1px solid #ccc',
                      borderRadius: '4px'
                    },
                  }}
                  isValidDate={this.isDateInAvailableRange}
                  value={this.state.filters.fromDt}
                  dateFormat="YYYY-MM-DD"
                  timeFormat="HH:mm"
                  closeOnSelect
                  onChange={(date) => { this.setState({ filters: { ...this.state.filters, fromDt: date }}) }}
                />

                <h3 className="mt-3 mb-1">Data de Fim</h3>
                <Datetime
                  inputProps={{
                    style: { textAlign: 'center' ,
                      width: '100%',
                      boxSizing: 'border-box',
                      transition: 'all .2s ease',
                      height: '38px',
                      fontSize: '1em',
                      border: '1px solid #ccc',
                      borderRadius: '4px'
                    },
                  }}
                  isValidDate={this.isDateInAvailableRange}
                  value={this.state.filters.toDt}
                  dateFormat="YYYY-MM-DD"
                  timeFormat="HH:mm"
                  closeOnSelect
                  onChange={(date) => { this.setState({ filters: { ...this.state.filters, toDt: date }}) }}
                /> */}

                {selectors().map((selector) => (
                  <div className="" key={selector.name}>
                    <h3 className="mt-3 mb-1">{selector.name}</h3>
                    <MultiSelector
                      options={selector.options}
                      selectedValues={selector.selectedValues}
                      name={selector.name}
                      onChange={selector.onChange}
                    />
                  </div>
                ))}



                <Modal
                  isOpen={this.state.saveFormOpen}
                  onRequestClose={() => this.setState({ saveFormOpen: false })}
                  ariaHideApp={false}
                  style={{
                    content: {
                      width: '50vw',
                      height: '30vh',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      borderRadius: '15px',
                      backgroundColor: '#f3f3f0',
                    },
                    overlay: {
                      zIndex: 1000,
                    },
                  }}
                >
                  <p className="subtitle mt-5">Guardar Relatório</p>

                  <input
                    className="input"
                    type="text"
                    placeholder="Nome do Relatório"
                    onChange={(e) => this.setState({ _reportNameInput: e.target.value })}
                  />

                  <div className="field">
                    <div className="buttons is-centered mt-6">
                      <button
                        className="button is-primary"
                        style={{ width: '180px' }}
                        onClick={this.saveReport}
                        disabled={this.state._reportNameInput && this.state._reportNameInput.length > 0 ? false : true}
                      >
                        Guardar
                      </button>

                      <button
                        className="button ml-5"
                        style={{ width: '180px' }}
                        onClick={() => this.setState({ saveFormOpen: false })}
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                </Modal>
              </div>
            </div>

            <div style={{ marginLeft: this.state.showFilters ? '20vw' : '3vw' }}>{renderData()}</div>
          </div>
        </>
      )
    }

    // const renderReport = () => {

    //   return (
    //     <div className="container">
    //       <div className="section pb-3">

    //         {dateSlider()}

    //         <div className="columns mt-3">

    //           {selectors().map(selector => (
    //             <div className="column" key={selector.name}>
    //               <h3 className="subtitle">{selector.name}</h3>
    //               <MultiSelector
    //                 options={selector.options}
    //                 selectedValues={selector.selectedValues}
    //                 name={selector.name}
    //                 onChange={selector.onChange}
    //               />
    //             </div>
    //           ))}
    //         </div>

    //       </div>

    //       <div className="mt-5">
    //         {this.state.data ?

    //           <Charts
    //             dashMode={this.props.dashMode}
    //             data={this.state.data}
    //             features={chartDefinitions}
    //             valuesFeature="CONSUMO"
    //             timeFeature="DATA"
    //           /> : <Loading/>}
    //       </div>
    //     </div>
    //   )
    // }

    return <div>{renderSideBar()}</div>
  }
}

export default withRouter(ReadingsExplorer)
